module.exports = __webpack_public_path__ + "img/right.41c99ef9.svg";